module.exports = __webpack_public_path__ + "static/img/exploit2.7861d499.png";